export const publicKeys = [
    { country: 'default', key: process.env.REACT_APP_GLOBAL_STRIPE_KEY },
    { country: 'AU', key: process.env.REACT_APP_AU_STRIPE_KEY },
    { country: 'GB', key: process.env.REACT_APP_GB_STRIPE_KEY },
];